'use client';

import { forwardRef, useContext } from 'react';

import { css, cx } from '@/styled-system/css';

import { MenuItemContext } from './context/menu-item.context';
import { menuItemLabelRecipe } from './styles/menu-item-label.styles';
import type { MenuItemLabelPropsInterface } from './types/menu-item-label.types';

/**
 * @since 10.0.0
 */
export const MenuItemLabel = forwardRef<HTMLSpanElement, MenuItemLabelPropsInterface>(
  (props: MenuItemLabelPropsInterface, forwardedRef) => {
    const { anchor, disabled } = useContext(MenuItemContext);
    const { className, css: cssProp, ...rest } = props;
    const styles = css(menuItemLabelRecipe.raw({ anchor, disabled }), cssProp);
    return (
      <span
        ref={forwardedRef}
        data-c11n-component="Menu.ItemLabel"
        data-c11n-version={__C11N_VERSION__}
        className={cx('c11n', 'c11n_menu__item-label', styles, className)}
        {...rest}
      />
    );
  },
);

MenuItemLabel.displayName = 'Menu.ItemLabel';
